import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Challenge } from 'src/types/shared/Challenge';

export const publishChallengeRequest = createAction('publishChallengeRequest');
export const publishChallengeSuccess = createAction<Challenge>('publishChallengeSuccess');
export const publishChallengeFailure = createAction('publishChallengeFailure');

export const publishChallenge = (id: number, revert: boolean) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(publishChallengeRequest());
    try {
        const { data } = await api.patch<null, Challenge>(
            `admin/challenges/${id}/publish?revert=${revert}`,
            null,
        );

        dispatch(publishChallengeSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, publishChallengeFailure, e);
    }
};
